import { lazyPage } from '@/lib/lazy-load'

const BillingHistoryPage = lazyPage(() => import('./BillingHistoryPage'))
export default BillingHistoryPage
